import { useLingui } from '@lingui/react/macro';
import { config } from './locales';

export const useDirection = () => {
  const { i18n } = useLingui();
  return (config?.[i18n.locale as keyof typeof config].dir || 'ltr') as
    | 'rtl'
    | 'ltr';
};
